export const LEASE_SIGNING_FLOW = 'leaseSigningFlow';
